export const bolepidemiologicos2025Arbovirosis = [
  {
    "etiqueta_elemento": "Boletin Semana 1 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 01 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 2 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 02 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 3 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 03 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 4 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 04 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 5 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 05 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 6 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 06 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 7 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 07 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 8 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 08 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 9 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 09 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 10 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 10 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 11 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 11 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 12 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 12 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 13 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 13 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 14 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 14 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 15 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 15 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 16 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 16 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 17 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 17 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 18 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 18 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 19 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 19 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 20 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 20 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 21 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 21 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 22 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 22 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 23 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 23 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 24 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 24 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 25 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 25 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 26 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 26 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 27 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 27 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 28 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 28 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 29 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 29 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 30 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 30 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 31 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 31 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 32 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 32 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 33 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 33 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 34 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 34 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 35 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 35 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 36 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 36 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 37 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 37 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 38 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 38 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 39 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 39 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 40 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 40 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 41 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 41 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 42 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 42 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 43 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 43 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 44 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 44 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 45 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 45 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 46 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 46 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 47 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 47 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 48 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 48 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 49 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 49 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 50 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 50 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 51 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 51 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 52 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 52 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin Semana 53 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/Arbovirosis/Boletin Arbovirosis Sem 53 2025.pdf",
  },
]